/*
 * Module corresponding to grid height testing
 */

rs.module("development/codedemosgridheight", [],

    function () {

        function initialize(jsSelectors) {

            var strategyToggle = $.js(jsSelectors.strategy);
            var autoHeightControls = $.js(jsSelectors.autoHeightOptions, { multiple: true });
            var exactCountControls = $.js(jsSelectors.exactCountOptions);

            function updateVisibility() {

                var sizeToFit = strategyToggle.val() === "true";

                autoHeightControls.toggleClass("d-none", !sizeToFit);
                exactCountControls.toggleClass("d-none", sizeToFit);
            }

            strategyToggle.change(updateVisibility);

            updateVisibility();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);